import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Table } from "antd";
import MainLayout from "../../../../layouts/MainLayout";
import { useDispatch } from "react-redux";
import { COLOR, FONT } from "../../../Config/Color";
import { getAdminTicketData } from "../../../../redux/actions/adminAction";
import moment from "moment";
import TicketResolveRemark from "../../../Component/TicketResolveRemark";
import { ImagePath } from "../../../../config/apiEndPoints";


const RecievedTickets = () => {
 
  const getAllUsersData = useSelector(
    (state) => state?.adminData?.employeeListData
  );
  const [query, setQuery] = useState("");
  const adminTicketsData = useSelector(
    (state) => state?.adminData?.adminTicketsData
  );
  const dispatch = useDispatch()
  const [modalOpen, setModalOpen] = useState(false);
  const [employee, setEmployee] = useState();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    dispatch(getAdminTicketData("admin"))
  }, [])


  // console.log("adminTicketsData", adminTicketsData);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };
  const columns = [
    {
      title: "SN.",
      dataIndex: "sn",
      key: "sn",
      render: (text, record, index) => index + 1,
      width: 60,
      fixed: "left",
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
      fixed: "left",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", width: 200 }}>
          <img
            src={
              record?.image ? record.image : "/assets/img/user.png"
            }
            style={{
              width: 50,
              height: 50,
              marginRight: 10,
              borderRadius: 10,
              border: "2px solid #E2E8F099",
            }}
            alt={record?.employee?.name ? `${record?.employee?.name}'s Photo` : "No Employee Photo"}
          />
          <span>
            {record?.employee?.name || "NA"}
          </span>
        </div>
      ),
    },

    {
      title: "EMPLOYEE CODE",
      width: 150,
      dataIndex: "type",
      filterMultiple: true,
      render: (_, record) => (
        <span>
          {record?.employee?.employee_code || "NA"}
        </span>
      ),
    },
    {
      title: "DESIGNATION",
      width: 150,
      dataIndex: "employee_code",
      render: (_, record) => (
        <span>
          {record?.employee?.designation || "NA"}
        </span>
      ),
    },
    {
      title: "TITLE",
      width: 150,
      dataIndex: "title",
      key: "title",
      render: (_, record) => {
        return (
          <div>
            <p style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }} className="m-0 p-0 text-capitalize">{record?.title}</p>
            {/*  */}
            {
              record?.attachments?.length > 0 &&
              <a href={ImagePath + record?.attachments[0]}
                className="text-primary"
                target="_blank">Attached File Link</a>
            }
          </div>
        )
      }
    },
    {
      title: "ISSUE",
      width: 250,
      dataIndex: "description",
      key: "description",
      render: (text) => {
        return (
          <div>
            <p style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }} className="m-0 p-0 text-capitalize">{text}</p>
           
          </div>
        )
      }
    },
    {
      title: "STATUS",
      width: 150,
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span  className={`ticket-status-${text == "pending" ? "pending" : "success"} `}>
          <i className="ti ti-circle-filled fs-5 me-1">
          </i>{text}
        </span>
      ),
    },
    {
      title: "TIME",
      dataIndex: "created_at",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
        >
          {text ? moment(text).format("hh:mm A") : "NA"}
        </span>
      ),
    },

    {
      title: "ACTION",
      width: 150,
      filtering: false,
      render: (_, rowData) => (
        <div>
          <select
            disabled={rowData?.status == "resolved"}
            onChange={(e) => {
              if(!(rowData?.status == "resolved")){
                setModalOpen({ rowData, statusValue: e.target.value });
              }
              // pending,in_progress,resolved,closed,rejected
            }}
            value={rowData?.status}
            className={`rvt-statues rv-${rowData?.status} `}>
            <option value={"pending"}>Pending</option>
            <option value={"in_progress"}>In Progress</option>
            <option value={"closed"}>Closed</option>
            {/* <option value={"cancel"}>Cancel</option> */}
            <option value={"resolved"}>Resolved</option>
            <option value={"rejected"}>Rejected</option>
          </select>
        </div>
      ),
    },
  ];



  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <div>
            <h2>Tickets</h2>
          </div>

          <div className="p-3 mt-4 bg-white rounded border " >
            <h3 className="text-dark fs-18 fw-600 bold pb-2">
              Tickets List ({adminTicketsData?.length})
            </h3>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div class="input-group w-25 m-0">
                <input type="text" class="form-control"
                  name="query"
                  value={query}
                  onChange={handleInputChange}
                  placeholder="Search..." />
                <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <span className="text-dark">
                    Employee:
                  </span>
                  <select
                    name="manager"
                    id="manager"
                    value={employee||""}
                    onChange={(e)=>{
                      setEmployee(e.target.value)
                    }}
                    required
                  >
                    <option value="">All Data</option>
                    {getAllUsersData?.map((data) => (
                      <option key={data?.id} value={data?.name}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </div>

                <button
                  onClick={()=>{setEmployee()}}
                  // disabled={isDisabled}
                  className={`px-3 py-1 rounded flex items-center justify-center transition-colors ${employee
                    ? "bg-blue-500 text-white hover:bg-blue-600"
                    : "bg-gray-200 text-black"
                    } ${employee ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  Clear Filter
                </button>

              </div>

            </div>

            <div
              style={{
                marginTop: "20px",
                width: "100%",
              }}
            >
              <Table
                columns={columns}
                className="dotted-border-table"
                rowClassName={() => "custom-row"}
                bordered={false}
                tableLayout="fixed"
                rowKey="key"
                scroll={{ y: "70vh", x: 1000 }}
                dataSource={adminTicketsData?.filter((item)=>{
                  if(employee || query){
                    console.log( employee  ,query ,"name");
                    
                    return item?.employee?.name?.toLowerCase()?.includes(employee?.toLowerCase() ||query?.toLowerCase())
                  }
                  return item
                })}
                pagination={{
                  pageSize: 5,
                  position: ["bottomRight"],
                }}
              />

              {showDialog && (
                <div className="dialog-backdrop">
                  <div className="dialog">
                    <p>Alert!</p>
                    <p>Do you want to delete employee details?</p>

                    <div className="dialog-buttons">
                      <button
                        // onClick={() => deleteEmployeeDetails()}
                        className="confirm-btn"
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => setShowDialog(false)}
                        className="cancel-btn"
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <TicketResolveRemark open={modalOpen} onClose={() => { setModalOpen() }} />
    </MainLayout>
  );
};

export default RecievedTickets;
